import {Component, OnInit} from '@angular/core';
import {setTheme} from 'ngx-bootstrap/utils';
import {AppService} from '@app/services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private appService: AppService) {
    setTheme('bs4');
  }

  ngOnInit(): void {
    this.appService.initWebPortalCommandListeners();
  }
}
